import { MessagesContainerComponent } from './messages-container';
import { ChatMessageComponent } from './chat-message';
import { ChatBoxComponent } from './chat-box';
import { chatRouting } from './chat.routing';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FromNowPipe, SortByDatePipe } from '../shared/pipes';

import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { ChatComponent }   from './chat.component';
import { ChatIndexComponent } from './chatindex';
import { ChatService } from './chat.service';
import { RegionThreadComponent } from './region-thread';
import { RegionElementComponent } from './region-element';
import { JoinRegionComponent } from './join-region';

import { SignalRService } from './signalR.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        SharedModule,
        chatRouting
    ],
    exports: [
        ChatComponent,
        ChatIndexComponent,
        RegionThreadComponent,
        JoinRegionComponent,
        RegionElementComponent,
        ChatBoxComponent,
        ChatMessageComponent,
        MessagesContainerComponent,
    ],
    declarations: [
        ChatComponent,
        ChatIndexComponent,
        RegionThreadComponent,
        JoinRegionComponent,
        RegionElementComponent,
        ChatBoxComponent,
        ChatMessageComponent,
        MessagesContainerComponent,
        FromNowPipe,
        SortByDatePipe,
    ],
    providers: [ChatService, SignalRService ],
})
export class ChatModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/chat.module.ts